import { render, staticRenderFns } from "./SecuritySetupModal.vue?vue&type=template&id=0087012a"
import script from "./SecuritySetupModal.vue?vue&type=script&lang=js"
export * from "./SecuritySetupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports